import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { FileContents } from "../index";

export const FileContentsField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    // component used in two fields: capKeysIptFile and capKeysOptFile
    const fieldName = field.name;
    const capKeysType = fieldName.includes("capKeysIpt") ? "capKeysIpt" : "capKeysOpt";

    return (
        <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
                // Get the value of the capKeysOpt or capKeysIpt
                const capKeysData = getFieldValue(capKeysType);

                return (
                    <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
                        <FileContents key={field.name} name={field.name} readOnly={readOnly} isSiblingContentPresent={!!capKeysData} />
                    </Form.Item>
                );
            }}
        </Form.Item>
    );
};
